export default {
  "env": "prod",
  "fonts": {
    "typekit": "pnc8vjj"
  },
  "optimize": {
    "container": "GTM-N9PSXFV",
    "property": "UA-109954910-1"
  }
};